import { createSelector } from "@kanda-libs/ks-frontend-services";
import { formatCompanies } from "components/company/CompanyTable/helpers";
import { type RootState, selectors } from "store";
import { filterJobs } from "components/job/JobTable/helpers";
import { getQueryFlags } from "./query";

export const getCompany = (state: RootState) => state.company;

export const getFormattedCompanies = createSelector(
  selectors.company.getEntitiesAsArray,
  selectors.monitor.getEntitiesAsArray,
  getQueryFlags,
  (companies, monitors, flags) =>
    formatCompanies(companies, flags.home.completedSetup, monitors)
);

export const getCompanyMonitor = createSelector(
  selectors.company.getEntity,
  selectors.monitor.getEntities,
  (company, monitors) => monitors[company?.id || ""]
);

export const getCompanyFilteredJobs = createSelector(
  selectors.company.getEntity,
  selectors.job.getEntitiesAsArray,
  (company, jobs) =>
    filterJobs(jobs, false, false, false, [], [], company?.id) || []
);

export const getCompanyRate = createSelector(
  selectors.company.getEntity,
  selectors.rate.getEntities,
  (company, rates) => rates[company?.id || ""]
);

const companySelectors = {
  ...selectors.company,
  getFormattedCompanies,
  getCompanyMonitor,
  getCompanyFilteredJobs,
  getCompanyRate,
};

export default companySelectors;
